import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";
import { CommonValues } from "../static/CommonValues";

 export class v_InvoiceNoteBus extends BaseBus
 { 
     constructor(busObj: v_InvoiceNoteBus = null) {
         let invNotePersonId =null
         if (busObj) { invNotePersonId = busObj.invoiceNotePersonId; }
         super(busObj);
         this.invoiceNotePersonId = invNotePersonId;
         if (CommonFunctions.hasValue(this.insertDt)) {
             this.insertDt = new Date(this.insertDt);
         }
         if (CommonFunctions.hasValue(this.updateDt)) {
             this.updateDt = new Date(this.updateDt);
         }
         this.isDraged = false;
     }

     CID(): any {
         return this.invoiceNoteId;
     }
     setId(id: any) {
         this.invoiceNoteId = id;
     }
     setParentId(id: any) {
         this.invoiceId = id;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
         if (!CommonFunctions.hasGuidValue(this.invoiceNotePersonId) && this.invoiceNotePersonId != CommonValues.Guid_Empty) {
             this.invoiceNotePersonId = personId;
         }
     }
     setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
         this.invoiceNotePersonId = personId;
     }
     get usesOrderValue(): boolean {
         return true;
     }
     get orderValue(): number {
         return this.sortOrder;
     }
     set orderValue(value: number) {
         if (value > 255) {
             this.sortOrder = 255;
         }
         else {
             this.sortOrder = value;
         }
         
     }
     setFromForm(data: v_InvoiceNoteBus) {
         super.setFromForm(data);
         let dateNow = CommonFunctions.getDateNow();
       //  dateNow = DateFunctions.getDateTimeWithUTCOffset(dateNow);
         if (this.hasId) {
             //this.updateDt = dateNow;
             //this.insertDt = data.insertDt;
             //this.insertUserId = data.insertUserId;
         }
         else {
             this.insertDt = dateNow;
             this.insertUserId = data.insertUserId;
         }
     }
    invoiceNoteId: string;
    invoiceNotes: string;
    isPrintable: boolean;
    sortOrder: number;
    personName: string;
    insertUserName: string;
    updateUserName: string;
    invoiceId: string;
    invoiceNotePersonId: string;
    insertDt: Date;
    insertUserId: string;
    updateDt: Date;
    updateUserId: string;
    isDraged: boolean;
 }
